import apiChange from '../apiChange';
import { ParamsBodyChangeSolicitation } from 'utils/typeServices';

type response = {
    success: boolean;
    message: string;
    errorCode: string;
    data: {
        cD_SOLICITACAO: number;
    };
}

export const GetChangeSolicitation = async ({ body }: { body: ParamsBodyChangeSolicitation }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<response>('/changeowner/getChangeSolicitation/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        return null;
    }
}